import { startOfMonth } from "date-fns";
import { GetSomeConciliacionParams } from "../params/GetSomeConciliacionParams";

const today = new Date();

export const filtrosConciliador: GetSomeConciliacionParams = {
   fechaIni: startOfMonth(today),
   fechaFin: today
};